import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminItinerary() {
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    category: "Departure",
    title: "",
    description: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/itinerary");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data itinerary");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveItem = async () => {
  try {

    if (editingId) {

      await api.patch(
        `/admin/master/itinerary/${editingId}`,
        form
      );

      toast.success("Itinerary berhasil diperbarui");

    } else {

      await api.post(
        "/admin/master/itinerary",
        form
      );

      toast.success("Itinerary berhasil ditambahkan");
    }

    setForm({
      category: "Departure",
      title: "",
      description: "",
    });

    setEditingId(null);

    loadData();

  } catch {
    toast.error("Gagal menyimpan itinerary");
  }
};

  const deleteItem = async (id) => {
    if (!window.confirm("Hapus itinerary ini?")) return;

    try {
      await api.delete(`/admin/master/itinerary/${id}`);
      toast.success("Itinerary berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus itinerary");
    }
  };

const editItem = (item) => {

  setEditingId(item.id);

  setForm({
    category: item.category || "Departure",
    title: item.title || "",
    description: item.description || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">
          Master Itinerary
        </h1>
      </div>

      <div className="grid gap-3">

        <select
          className="border rounded px-3 py-2"
          value={form.category}
          onChange={(e) =>
            setForm({
              ...form,
              category: e.target.value,
            })
          }
        >
          <option value="Departure">Departure</option>
          <option value="Arrival">Arrival</option>
          <option value="Umroh">Umroh</option>
          <option value="Ziarah">Ziarah</option>
          <option value="Transfer">Transfer</option>
          <option value="Return">Return</option>
        </select>

        <input
          className="border rounded px-3 py-2"
          placeholder="Title"
          value={form.title}
          onChange={(e) =>
            setForm({
              ...form,
              title: e.target.value,
            })
          }
        />

        <textarea
          rows={5}
          className="border rounded px-3 py-2"
          placeholder="Description"
          value={form.description}
          onChange={(e) =>
            setForm({
              ...form,
              description: e.target.value,
            })
          }
        />
      </div>

      <button
        onClick={saveItem}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
       {editingId
  ? "Update Itinerary"
  : "Tambah Itinerary"}
      </button>

{editingId && (
  <button
    onClick={() => {

      setEditingId(null);

      setForm({
        category: "Departure",
        title: "",
        description: "",
      });

    }}
    className="ml-3 border px-4 py-2 rounded"
  >
    Batal
  </button>
)}

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Category</th>
            <th className="border p-2">Title</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">
                {item.category}
              </td>

              <td className="border p-2">
                {item.title}
              </td>

<td className="border p-2 space-x-3">

  <button
    onClick={() => editItem(item)}
    className="text-blue-600 font-medium"
  >
    Edit
  </button>

  <button
    onClick={() => deleteItem(item.id)}
    className="text-red-600 font-medium"
  >
    Hapus
  </button>

</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
